import React, { useState } from 'react';
import {
  FDIcon, FDStack,
} from '@facet-wealth/design';
import PropTypes from 'prop-types';
import { useTheme } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Paper from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Paper';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import { dataAttrs } from 'Helpers/Testing';
import Button1 from 'Components/ComponentLibrary/Components/Buttons/Button1';


function CustomGoalItem({ onDelete, onBlur }) {
  const theme = useTheme();
  const [loading, setLoading] = useState(false);
  const { resource } = useMetaLayoutContext();

  const handleDelete = async () => {
    setLoading(true);
    await onDelete(resource);
    setLoading(false);
  };

  return (
    <Paper
      style={{
        borderRadius: '16px',
        backgroundColor: `${theme.palette.facet.accentBlue20}`,
      }}
      {...dataAttrs('onboarding-custom-goal')}
    >
      <FDStack direction={'row'} alignItems={'center'}>
        <MetaControlField attr={'name'} onInlineSubmit={() => onBlur(resource)} simpleRootStyle />
        <Button1
          onClick={handleDelete}
          color={'primary'}
          size={'small'}
          variant={'icon'}
          disabled={loading}
          round
          {...dataAttrs('custom-goal-delete-button')}
        >
          <FDIcon icon={'close'} color={'error'} size={'sm'} />
        </Button1>
      </FDStack>
    </Paper>
  );
}

CustomGoalItem.propTypes = {
  onDelete: PropTypes.func.isRequired,
  onBlur: PropTypes.func.isRequired,
};

export { CustomGoalItem };
